import { formatDashboardNumber } from './formatDashboardNumber'

interface FunnelMetricOptions {
  isBaseline?: boolean
  naWhenZero?: boolean
}

export function formatCampaignFunnelMetric(
  value: number | null | undefined,
  previousValue: number | null | undefined,
  options?: FunnelMetricOptions,
): string {
  const { isBaseline = false, naWhenZero = false } = options || {}
  const current = Number(value)

  if (naWhenZero && (!Number.isFinite(current) || current === 0)) {
    return 'N/A'
  }

  const nominal = Number.isFinite(current) ? current : 0

  if (isBaseline) {
    return `100% (${formatDashboardNumber(nominal)})`
  }

  const previous = Number(previousValue) || 0
  const pct = previous > 0 ? Math.round((nominal / previous) * 100) : 0

  return `${pct}% (${formatDashboardNumber(nominal)})`
}

export function campaignFunnelPct(
  value: number | null | undefined,
  previousValue: number | null | undefined,
  options?: FunnelMetricOptions,
): string {
  const { isBaseline = false, naWhenZero = false } = options || {}
  const current = Number(value)

  if (naWhenZero && (!Number.isFinite(current) || current === 0)) {
    return 'N/A'
  }

  if (isBaseline) {
    return '100'
  }

  const nominal = Number.isFinite(current) ? current : 0
  const previous = Number(previousValue) || 0
  return previous > 0 ? String(Math.round((nominal / previous) * 100)) : '0'
}
